
//rspostaged.geotech.solutions
export const API_URL_DOMAIN = "firewatchserver.rspo.org";// rspostaged.geotech.solutions //"firewatchsystem2.rspo.org"; //localhost:50293  test.geotech.solutions authen.thegeomap.com rspotest.geotech.solutions localhost:59658 localhost:59658
export const MAP_URL_DOMAIN = "firewatchserver.rspo.org";//"firewatchsystem2.rspo.org"; //localhost:63290 thegeomap.com firewatchsystem1.rspo.org
export const MAPCLIENT_URL_DOMAIN = "firemap.rspo.org";//"firemap.rspo.org";  //map.geotechsolutions.ltd //maptest.geotech.solutions localhost:50506
export const API_URL_DOMAIN2 = "firewatch.rspo.org";//"firewatch.rspo.org"; 


// WEBPACK FOOTER //
// ./src/utils/constants.js